<template>
  <div
    :id="id_name"
    @click="generate_excel">
    <slot>
      {{button_text}}{{ajaxGetKey}}
    </slot>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        meta: [],
        data: []
        // keys: {}
      }
    },
    props: {
      button_text: {
        type: String,
        default: "Download Excel"
      },
      name: {
        type: String,
        default: "data.xlsx"
      },
      keys: {
        default: Array
      },
      ajaxUrl: {
        default: false
      },
      ajaxGetKey: {
        default: false
      },
      ajaxPar: {
        default: {}
      },
      ajaxType: {
        default: "get"
      },
      colData: {
        default: false
      }
    },
    mounted () {
    },
    computed: {
      id_name () {
        var now = new Date().getTime()
        return "export_" + now
      }
    },
    methods: {
      emitXmlHeader: function () {
        var headerRow = "<tr>\n"
        // for (var colName in this.keys) {
        //   headerRow += "  <th style="text-align: left;">\n";
        //   headerRow += colName + "\n";
        //   headerRow += "  </th>\n";
        // }
        this.keys.forEach((item) => {
          headerRow += "  <th style='text-align: left;'>\n"
          headerRow += item + "\n"
          headerRow += "  </th>\n"
        })

        headerRow += "</tr>\n"
        // var metatags = null
        // this.meta.forEach(function (element) {
        //   metatags += "<meta "
        //   element.forEach(function (m) {
        //     metatags += m.key + "='" + m.value + "' "
        //   })
        //   metatags += ">"
        // })
        return "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head>" + "<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>\n" +
          "<thead>\n\n" +
          headerRow +
          "</thead>\n\n" +
          "</tbody>\n"
      },
      emitXmlFooter () {
        return "\n</tbody>\n" +
          "</table>\n" +
          "</body>\n" +
          "</html>\n"
      },
      jsonToHtml: function (jsonObject) {
        var row = null
        var col = null
        var xml = null
        var data = typeof jsonObject !== "object"
          ? JSON.parse(jsonObject)
          : jsonObject
        xml = this.emitXmlHeader()

        for (row = 0; row < data.length; row++) {
          xml += "<tr>\n"

          for (col in data[row]) {
            xml += "  <td style='text-align: left;'>\n"
            xml += (String(data[row][col]) ? String(data[row][col]) : "") + "\n"
            xml += "  </td>\n"
          }
          xml += "</tr>\n"
        }
        xml += this.emitXmlFooter()
        return xml
      },
      generate_excel () {
        var uri = "data:application/vnd.ms-excel;base64,"
        var base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }

        if (this.ajaxUrl) {
          let ajaxPar = this.ajaxType === "post" ? this.ajaxPar : {params: this.ajaxPar}
          this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then((res) => {
            let getVal = (obj, arr) => {
              if (arr.length > 1) {
                return getVal(obj[arr[0]], arr.slice(1))
              } else {
                return obj[arr[0]]
              }
            }
            console.log(res)
            this.data = getVal(res, this.ajaxGetKey)

            var href = uri + base64(this.jsonToHtml(this.data))
            // a.href = href
            // a.download = this.name;
            window.location.href = href
          })
        } else if (this.colData) {
          this.data = this.colData
          var href = uri + base64(this.jsonToHtml(this.data))
          window.location.href = href
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// jsonExcel.vue?a818c320